import Vue from 'vue'
import ShowDown from 'showdown'
// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
export default new Vue({
  data: {
    _isDesktop: true,
    _navMain: [
      {
        title: 'home',
        name: 'landing',
        path: '/',
        params: {}
      }, {
        title: 'about',
        name: 'about',
        path: '/about',
        params: {}
      }, {
        title: 'iOS',
        name: 'showcase',
        path: '/showcase/ios',
        params: {
          type: 'ios'
        }
      }, {
        title: 'contact',
        name: 'contact',
        path: '/contact',
        params: {}
      }
      // , {
      //   title: 'contact',
      //   name: 'contact',
      //   // path: '/contact'
      //   subnavOpen: false,
      //   subnav: [
      //     {
      //       name: 'about',
      //       title: 'About',
      //       path: '/about'
      //     }, {
      //       name: 'test-2',
      //       title: 'Test 2',
      //       path: 'test-2'
      //     }
      //   ]
      // }
    ],
    _navSocial: [
      {
        name: 'facebook',
        title: 'noctorus.studio',
        fa: 'facebook',
        path: 'https://www.facebook.com/noctorus.studio'
      }, {
        name: 'twitter',
        fa: 'twitter',
        path: 'https://www.twitter.com/noctorus'
      }, {
        name: 'medium',
        fa: 'medium',
        path: 'https://www.medium.com/@noctorus'
      }, {
        name: 'github',
        fa: 'github',
        path: 'https://www.github.com/morph85'
      }
    ],
    _navPhone: '01-234-5678',
    _navEmail: 'ivan@noctorus.studio'
  },
  computed: {
    isDesktop: {
      get: function () {
        return this._isDesktop
      },
      set: function (isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop
          this.$emit('isDesktopChanged', isDesktop)
        }
      }
    }
  },
  watch: {
  },
  methods: {
    getHtml: function (content) {
      var converter = new ShowDown.Converter()
      var html = converter.makeHtml(content)
      return html
    },

    getSocialNav: function (type) {
      console.log(this._data._navSocial)
      for (var i = 0; i < this._data._navSocial.length; i++) {
        var navItem = this._data._navSocial[i]
        if (navItem.name === type) {
          return navItem
        }
      }
      return undefined
    },

    detectIE: function () {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ')
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
      }

      var trident = ua.indexOf('Trident/')
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
      }

      var edge = ua.indexOf('Edge/')
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
      }

      // other browser
      return false
    }
  }
}) // <-- in this case access using import EventBus



// WEBPACK FOOTER //
// ./src/controllers/EventBus.js